import appRoot from './appRoot';
import listScreen from './listScreen';
import { createContentComponent } from './modals/createContent';
import { notApplicableProposalsComponent } from './modals/notApplicableProposals';
import { publishDateModal } from './modals/publishDate';
import { reviewSuggestionsModal } from './modals/reviewSuggestions';
import { submitSuggestionsModal } from './modals/submitSuggestions';
import structureScreen from './structureScreen';

export default angular
  .module('redactieScreenComponents', [])
  .component('appRoot', appRoot)
  .component('listScreen', listScreen)
  .component('structureScreen', structureScreen)
  .controller('publishDateModal', publishDateModal)
  .component('createContentModal', createContentComponent)
  .controller('submitSuggestionsModal', submitSuggestionsModal)
  .controller('reviewSuggestionsModal', reviewSuggestionsModal)
  .component('notApplicableProposalsModal', notApplicableProposalsComponent);
